import { React } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const fallbackUrl =
  "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80";

const HeroSectionCard = ({ slideImages }) => {
  const imagesArray = Array.isArray(slideImages)
    ? slideImages
    : slideImages
    ? [slideImages]
    : [];
    
  return (
    <>
      <div className="slider-wrapper rounded-lg border-0 overflow-hidden">
        {imagesArray?.length > 1 ? (
          <Slide autoplay transitionDuration={100} arrows={false} easing="ease">
            {imagesArray &&
              imagesArray.map((slideImage, index) => (
                <div key={index} className="slides__section">
                  <img
                    src={slideImage}
                    alt={`Slide ${index + 1}`}
                    onError={(e) => (e.target.src = fallbackUrl)}
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
          </Slide>
        ) : imagesArray?.length == 1 ? (
          <img
            src={imagesArray[0]}
            alt="Slide"
            onError={(e) => (e.target.src = fallbackUrl)}
            style={{
              width: "100%",
              height: "350px",
              objectFit: "cover",
            }}
          />
        ) : (
          <img
            src={fallbackUrl}
            alt="Default Slide"
            style={{
              width: "100%",
              height: "350px",
              objectFit: "cover",
            }}
          />
        )}
      </div>
    </>
  );
};

export default HeroSectionCard;
